import React from 'react';
import classNames from 'classnames';
import styles from './HistoryModal.module.scss';
import { Icon, IconList } from 'components/core';
import { IconSize, IconType, IconVariant } from 'components/core/Icon/Icon';
import { AuditEvent } from 'query/study/AuditEvents';

type IconDetail = {
  pattern: RegExp;
  variant: IconVariant;
  inverse?: boolean;
  size?: IconSize;
  icon: IconType;
};

const IconDetails: IconDetail[] = [
  {
    pattern: /imported/,
    variant: 'primary',
    inverse: true,
    size: 'md',
    icon: IconList.solid.faCloudDownload,
  },
  {
    pattern: /note\.create/,
    variant: 'neutral',
    icon: IconList.light.faMessageLines,
  },
  {
    pattern: /note\.update/,
    variant: 'neutral',
    icon: IconList.light.faMessagePen,
  },
  {
    pattern: /note\.destroy/,
    variant: 'neutral',
    icon: IconList.light.faMessageXmark,
  },
  {
    pattern: /(\.move_back|study\.previous|study_returned)/,
    variant: 'warning',
    inverse: true,
    size: 'xs',
    icon: IconList.solid.faArrowLeft,
  },
  {
    pattern: /(study\.next|rct_excluded|pics_excluded)/,
    variant: 'success',
    inverse: true,
    size: 'xs',
    icon: IconList.solid.faArrowRight,
  },
  {
    pattern: /vote\.(yes|include)/,
    variant: 'neutral',
    icon: IconList.light.faCircleCheck,
  },
  {
    pattern: /vote\.(no|exclude)/,
    variant: 'neutral',
    icon: IconList.light.faCircleXmark,
  },
  {
    pattern: /vote\.maybe/,
    variant: 'neutral',
    icon: IconList.light.faCircleQuestion,
  },
  {
    pattern: /vote\.undo/,
    variant: 'neutral',
    size: 'md',
    icon: IconList.light.faArrowRotateLeft,
  },
  {
    pattern: /document\.create/,
    variant: 'neutral',
    icon: IconList.light.faFileLines,
  },
  {
    pattern: /document\.destroy/,
    variant: 'neutral',
    size: 'xl',
    icon: IconList.light.faFileCircleXmark,
  },
  {
    pattern: /\.start$/,
    variant: 'neutral',
    size: 'xl',
    icon: IconList.light.faFilePen,
  },
  {
    pattern: /reviewer\.complete$/,
    variant: 'success',
    inverse: true,
    size: 'xs',
    icon: IconList.solid.faCheck,
  },
  {
    pattern: /(risk_of_bias|data_extraction)\.complete$/,
    variant: 'neutral',
    size: 'xl',
    icon: IconList.light.faFileCircleCheck,
  },
  {
    pattern: /\.merged\./,
    variant: 'neutral',
    icon: IconList.light.faMerge,
  },
  {
    pattern: /\.unmerged\./,
    variant: 'neutral',
    icon: IconList.light.faSplit,
  },
  {
    pattern: /reviewer\.reassign/,
    variant: 'neutral',
    size: 'md',
    icon: IconList.light.faArrowsRotate,
  },
  {
    pattern: /mark_as_duplicate/,
    variant: 'neutral',
    icon: IconList.light.faClone,
  },
];

type HistoryIconProps = {
  auditEvent: AuditEvent;
};

export const HistoryIcon = ({ auditEvent }: HistoryIconProps) => {
  const match = IconDetails.find((detail) =>
    auditEvent.name.match(detail.pattern)
  );

  return (
    <div className={classNames(styles.iconWrapper)}>
      <Icon
        variant={match?.variant || 'neutral'}
        inverse={match?.inverse || false}
        size={match?.size || 'lg'}
        icon={match?.icon || IconList.light.faPlus}
      />
    </div>
  );
};
